const initialState = {
  scenarios: [],
  isLoadingScenarios: false,

  scenarioMembersData: [],
  isLoadingScenarioMembersData: false,

  countries: [],
  isLoadingCountries: false,
};

export default initialState;
